/**
 * Ray's Loyalty — open Shopify <shopify-account> sheet (guest sign-in drawer).
 * Sheet opens only when the avatar button inside shopify-account is clicked.
 * Falls back to login URL if the sheet does not open.
 */
(function () {
  'use strict';

  var OPEN_EVENT = 'rays-loyalty:account-sheet-open';
  var CLOSE_EVENT = 'rays-loyalty:account-sheet-close';
  var TRIGGER_SELECTOR =
    '.js-rays-open-shopify-account, .js-rays-pc-open-shopify-account, [data-rl-open-login]';

  var openingLock = false;
  var lastOpenAt = 0;

  function loginFallbackUrl(trigger) {
    if (trigger && trigger.tagName === 'A') {
      var href = String(trigger.getAttribute('href') || '').trim();
      if (href && href !== '#') return href;
    }
    var u =
      (window.routes && window.routes.account_login_url) ||
      (window.__RAYS_LOYALTY__ && window.__RAYS_LOYALTY__.loginUrl) ||
      '/account/login';
    u = String(u || '/account/login').trim();
    return u && u !== '#' ? u : '/account/login';
  }

  function isShopifyAccountDefined() {
    return !!(
      window.customElements &&
      typeof window.customElements.get === 'function' &&
      window.customElements.get('shopify-account')
    );
  }

  function whenShopifyAccountReady(cb) {
    if (isShopifyAccountDefined()) {
      cb();
      return;
    }
    var done = false;
    function run() {
      if (done) return;
      done = true;
      cb();
    }
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      var timer = window.setTimeout(run, 500);
      window.customElements
        .whenDefined('shopify-account')
        .then(function () {
          window.clearTimeout(timer);
          run();
        })
        .catch(function () {
          window.clearTimeout(timer);
          run();
        });
      return;
    }
    run();
  }

  function clickSignedOutAvatar(host) {
    if (!host) return false;
    if (!host.shadowRoot) return false;
    var btn =
      host.shadowRoot.querySelector('button[part="signed-out-avatar"]') ||
      host.shadowRoot.querySelector('[part="signed-out-avatar"]');
    if (!btn || typeof btn.click !== 'function') return false;
    try {
      host.focus({ preventScroll: true });
    } catch (f) {}
    btn.click();
    return true;
  }

  function collectHosts() {
    var ordered = [];
    var seen = [];

    function add(host) {
      if (!host || seen.indexOf(host) >= 0) return;
      seen.push(host);
      ordered.push(host);
    }

    /* Prefer visible header/drawer triggers — sheet opens reliably from these. */
    add(document.querySelector('.header-account--header .js-header-account-guest-trigger'));
    add(document.querySelector('.header-account--drawer .js-header-account-guest-trigger'));
    add(document.querySelector('shopify-account[data-rays-pc-account-proxy]'));
    add(document.querySelector('shopify-account[data-header-account-sheet]'));
    add(document.querySelector('shopify-account[data-rays-account-proxy]'));
    add(document.querySelector('.js-header-account-guest-trigger'));
    return ordered;
  }

  function tryOpenOnce() {
    if (!isShopifyAccountDefined()) return false;
    var hosts = collectHosts();
    for (var i = 0; i < hosts.length; i++) {
      if (clickSignedOutAvatar(hosts[i])) return true;
    }
    return false;
  }

  function openAccountSheet(options) {
    var opts = options || {};
    var now = Date.now();
    if (openingLock || now - lastOpenAt < 500) return false;
    openingLock = true;
    lastOpenAt = now;

    var opened = false;
    var done = false;
    var fallbackUrl = opts.fallbackUrl || loginFallbackUrl(opts.trigger);

    function releaseLock() {
      openingLock = false;
    }

    function onNativeOpen() {
      opened = true;
    }

    document.addEventListener(OPEN_EVENT, onNativeOpen, { once: true });

    function finish() {
      if (done) return;
      done = true;
      document.removeEventListener(OPEN_EVENT, onNativeOpen);
      releaseLock();
      if (!opened && opts.fallback !== false) {
        window.location.assign(fallbackUrl);
      }
    }

    var hardFallback = window.setTimeout(finish, 600);

    function runAttempts(attemptIndex) {
      tryOpenOnce();
      if (opened) {
        window.clearTimeout(hardFallback);
        window.setTimeout(finish, 50);
        return;
      }
      if (attemptIndex >= 5) return;
      window.setTimeout(function () {
        runAttempts(attemptIndex + 1);
      }, 120);
    }

    whenShopifyAccountReady(function () {
      if (!isShopifyAccountDefined()) {
        finish();
        return;
      }
      runAttempts(0);
    });

    return true;
  }

  function bindDocumentTriggers() {
    if (document.documentElement.dataset.rlAccountSheetBound === '1') return;
    document.documentElement.dataset.rlAccountSheetBound = '1';

    document.addEventListener(
      'click',
      function (e) {
        var trigger = e.target.closest(TRIGGER_SELECTOR);
        if (!trigger) return;
        if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault();
        e.stopPropagation();
        openAccountSheet({ fallback: true, trigger: trigger });
      },
      true
    );
  }

  function watchAccountHosts() {
    document.querySelectorAll('shopify-account').forEach(function (host) {
      if (host.dataset.rlAccountSheetWatched === '1') return;
      host.dataset.rlAccountSheetWatched = '1';
      host.addEventListener('open', function () {
        document.dispatchEvent(new CustomEvent(OPEN_EVENT));
      });
      host.addEventListener('close', function () {
        document.dispatchEvent(new CustomEvent(CLOSE_EVENT));
      });
    });
  }

  function boot() {
    bindDocumentTriggers();
    watchAccountHosts();
    whenShopifyAccountReady(watchAccountHosts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', watchAccountHosts);

  function attachApi() {
    var RL = window.RaysLoyalty || {};
    RL.openAccountSheet = openAccountSheet;
    RL.loginUrl = RL.loginUrl || function () {
      return loginFallbackUrl();
    };
    window.RaysLoyalty = RL;
    window.RlAccountSheet = { open: openAccountSheet };
  }

  attachApi();
  document.addEventListener('DOMContentLoaded', attachApi);
})();
